import {useSelector} from 'react-redux';

import {selectLastSsoSessionApplyAt} from '@/state/selectors/media';

import useSsoCookieRefresh from './useSsoCookieRefresh';

const useAppSsoCookieRefresh = (): void => {
    const lastSsoSessionApplyAt = useSelector(selectLastSsoSessionApplyAt);
    const disabled = lastSsoSessionApplyAt == null;

    useSsoCookieRefresh({disabled});
};

export default useAppSsoCookieRefresh;
